export enum COMMUNITIES {
    /**
     * @value After saving, your video will be available for everybody when encoding is over.
     */
    ENCODING_MESSAGE = 'PLAY.VIDEO_UPLOAD_PROGRESS_ENCODING_MESSAGE',
    /**
     * @value Insert a video
     * @description The title of the insert video dialog
     */
    INSERT_VIDEO = 'FRONT.INSERT_VIDEO_DIALOG.TITLE',
    /**
     * @value Pick from gallery
     * @description Text used for example to label a button inviting the user to choose a video in the video gallery.
     */
    PICK_FROM_VIDEO_GALLERY = 'PLAY.PICK_VIDEO_FROM_GALLERY',
    /**
     * @value Video is ready to be inserted
     */
    READY_MESSAGE = 'PLAY.INSERT_VIDEO_READY',
    /**
     * @value Select the language spoken in the video to generate automatic subtitles. Subtitles are automatically translated in the supported site languages.
     * @description Notify user of automatic translation
     */
    TRANSCRIPT_DETAILS = 'PLAY.TRANSCRIPT_DETAILS',
    /**
     * @value Upload from computer
     * @description Label used on video upload button from a desktop computer device
     */
    UPLOAD_VIDEO_FROM_COMPUTER = 'PLAY.UPLOAD_VIDEO_FROM_COMPUTER',
    /**
     * @value Upload from device
     * @description Label used on video upload button for cellphones and tablets
     */
    UPLOAD_VIDEO_FROM_DEVICE = 'PLAY.UPLOAD_VIDEO_FROM_DEVICE',
    /**
     * @value Upload from Google Drive
     * @description List item from widget upload video dropdown
     */
    UPLOAD_VIDEO_FROM_DRIVE = 'PLAY.UPLOAD_VIDEO_FROM_DRIVE',
    /**
     * @value Video uploaded
     * @description Progress state of video : uploaded
     */
    VIDEO_UPLOADED = 'PLAY.VIDEO_UPLOAD_PROGRESS_UPLOADED',
}
